import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import logoNavigateur from '../assets/logoNavigateur.png';
import capebLogo from '../assets/capeb.jpg';
import qualipacLogo from '../assets/logo-qualipac-RGE.PNG';

function FooterLogo() {
  return (
    <div className="footer__logo-mark">
      <img
        src={logoNavigateur}
        alt="Logo Soclimate"
        className="footer__logo-img"
      />

      <span className="footer__logo-text">
        <span className="footer__logo-soc">SOC</span>
        <span className="footer__logo-limate">LIMATE</span>
      </span>
    </div>
  );
}

export default function Footer() {
  const navigate = useNavigate();

  const goTo = (anchor) => {
    const isHome =
      window.location.pathname === '/' || window.location.pathname === '';

    if (isHome) {
      const el = document.getElementById(anchor);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(`/#${anchor}`);
    }
  };

  const goToPath = (path) => {
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="footer__accent" />

      <div className="footer__top">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <button
                className="footer__logo-btn"
                onClick={() => goTo('accueil')}
                type="button"
                aria-label="Retour à l'accueil"
              >
                <FooterLogo />
              </button>

              <p className="footer__tagline">
                Votre spécialiste en climatisation et pompe à chaleur en
                Île-de-France. Certifié RGE QualiPAC.
              </p>

              <div className="footer__certs">
                <div className="footer__cert-card footer__cert-card--qualipac">
                  <img
                    src={qualipacLogo}
                    alt="Certification RGE QualiPAC"
                    className="footer__cert-img"
                  />
                </div>

                <div className="footer__cert-card footer__cert-card--capeb">
                  <img
                    src={capebLogo}
                    alt="Membre CAPEB"
                    className="footer__cert-img"
                  />
                </div>
              </div>

              <div className="footer__social">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-btn"
                  aria-label="Facebook"
                >
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
                  </svg>
                </a>

                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-btn"
                  aria-label="Instagram"
                >
                  <svg
                    width="16"
                    height="16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <rect x="2" y="2" width="20" height="20" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
                  </svg>
                </a>

                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-btn"
                  aria-label="LinkedIn"
                >
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                </a>
              </div>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">Navigation</h4>

              <ul className="footer__links">
                {[
                  { label: 'Accueil', anchor: 'accueil' },
                  { label: 'À propos', anchor: 'apropos' },
                  { label: 'Nos réalisations', anchor: 'realisations' },
                  { label: 'Avis clients', anchor: 'avis' },
                  { label: 'Partenaires', anchor: 'partenaires' },
                ].map((link) => (
                  <li key={link.anchor}>
                    <button
                      className="footer__link"
                      onClick={() => goTo(link.anchor)}
                      type="button"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">Services</h4>

              <ul className="footer__links">
                {[
                  { label: 'Climatisation', path: '/solution#climatisation' },
                  { label: 'Pompe à chaleur', path: '/solution#pompe-chaleur' },
                  { label: 'Ventilation', path: '/solution#ventilation' },
                  { label: 'Entretien', path: '/solution#entretien' },
                  { label: 'Demander un devis', anchor: 'contact' },
                ].map((link) => (
                  <li key={link.label}>
                    {link.path ? (
                      <button
                        className="footer__link"
                        onClick={() => goToPath(link.path)}
                        type="button"
                      >
                        {link.label}
                      </button>
                    ) : (
                      <button
                        className="footer__link"
                        onClick={() => goTo(link.anchor)}
                        type="button"
                      >
                        {link.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>

              <h4 className="footer__col-title footer__col-title--spaced">
                Zone
              </h4>

              <ul className="footer__links">
                <li>
                  <span className="footer__link footer__link--muted">
                    Île-de-France
                  </span>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">Contact</h4>

              <ul className="footer__contact-list">
                <li>
                  <div className="footer__contact-icon">
                    <svg
                      width="14"
                      height="14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.89 9.11 19.79 19.79 0 01.82.5 2 2 0 012.81 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 7.91a16 16 0 006 6l.91-1a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z" />
                    </svg>
                  </div>
                  <div>
                    <span>Téléphone</span>
                    <a href="tel:0618011895">06 18 01 18 95</a>
                  </div>
                </li>

                <li>
                  <div className="footer__contact-icon">
                    <svg
                      width="14"
                      height="14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <div>
                    <span>Email</span>
                    <a href="mailto:soclimate.95@gmail.com">
                      soclimate.95@gmail.com
                    </a>
                  </div>
                </li>

                <li>
                  <div className="footer__contact-icon">
                    <svg
                      width="14"
                      height="14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                  </div>
                  <div>
                    <span>Adresse</span>
                    <address>
                      1 rue de Belloy
                      <br />
                      95570 Villaines-sous-Bois
                    </address>
                  </div>
                </li>

                <li>
                  <div className="footer__contact-icon">
                    <svg
                      width="14"
                      height="14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 6v6l4 2" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div>
                    <span>Horaires</span>
                    <em>Lun–Ven : 8h–18h · Sam : 9h–13h</em>
                  </div>
                </li>
              </ul>

              <button
                className="footer__cta-btn"
                onClick={() => goTo('contact')}
                type="button"
              >
                Demander un devis gratuit
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-inner">
            <p>
              © {new Date().getFullYear()} SOCLIMATE · 1 rue de Belloy, 95570
              Villaines-sous-Bois
            </p>

            <div className="footer__bottom-links">
              <a href="/mentions-legales">Mentions légales</a>
              <a href="/confidentialite">Politique de confidentialité</a>
              <a href="/cgv">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}